import faker from 'faker'
import moment from 'moment'
import hres83eLabels from 'assets/labels/hres83e'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres83eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 500
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        assetno: (faker.lorem.word()).substring(0, 8),
        desc_assetno: faker.lorem.word(),
        staappr: 'B',
        desc_staappr: faker.lorem.word(),
        timperiod: moment().format('hh:mm') + ' - ' + moment().format('hh:mm'),
        codempid: faker.name.findName(),
        desc_codempid: faker.name.findName(),
        codcomp: faker.lorem.word(),
        desc_codcomp: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  assetDetail () {
    let mockAssetDetail = {
      assetno: (faker.lorem.word()).substring(0, 8),
      desc_assetno: faker.lorem.word(),
      dterec: moment().format('DD/MM/YYYY'),
      desnote: faker.lorem.word(),
      srcasset: faker.lorem.word(),
      typasset: (faker.lorem.word()).substring(0, 8),
      desc_typasset: faker.lorem.word(),
      codunit: (faker.lorem.word()).substring(0, 8),
      desc_codunit: faker.lorem.word(),
      namimage: faker.lorem.word(),
      namimagepath: '',
      qtybal: '99'
    }

    return mockAssetDetail
  },
  calendar () {
    let mockRows = []
    const mockTotal = 31
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereserv: Math.floor(Math.random() * 31) + '/08/2017'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  calendarDetail () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        seqno: Math.floor(Math.random() * 100) + 1,
        desc_codempid: faker.lorem.word(),
        timperiod: '10:00 - 11:00',
        desc_staappr: faker.lorem.word(),
        staappr: faker.lorem.word(),
        desc_codappr: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  reserveCreate () {
    let mockReserveCreate = {
      dtereq: moment().format('DD/MM/YYYY'),
      seqno: Math.floor(Math.random() * 100) + 1,
      timstrt: '',
      timend: '',
      staappr: 'B',
      desc_staappr: 'จอง',
      object: '',
      remark: '',
      qtypers: '',
      codempid: (faker.lorem.word()).substring(0, 8),
      desc_codempid: faker.lorem.word(),
      codappr: '',
      desc_codappr: ''
    }

    return mockReserveCreate
  },
  reserveDetail () {
    let mockReserveDetail = {
      dtereq: moment().format('DD/MM/YYYY'),
      seqno: Math.floor(Math.random() * 100) + 1,
      timstrt: '16:00',
      timend: '18:00',
      staappr: 'B',
      desc_staappr: 'จอง',
      // object: faker.lorem.word(),
      remark: faker.lorem.word(),
      qtyreserv: Math.floor(Math.random() * 100),
      codempid: (faker.lorem.word()).substring(0, 8),
      desc_codempid: faker.lorem.word(),
      codappr: (faker.lorem.word()).substring(0, 8),
      desc_codappr: faker.lorem.word()
    }

    return mockReserveDetail
  },
  reserveCancel () {
    return labels.mockPostMessage
  },
  reserveSave () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres83e/mocker.js